import React, { useState, useEffect } from 'react';
import { RestHelperNoAuth } from "../helper/restHelperNoAuth";
import { Link } from 'react-router-dom'
import mixpanel from "mixpanel-browser";
import './title-hero.css';
import HomepagePersonaCards from './homepage-persona-cards';
import HomepageServices from './homepage-services';
import HomepageMarkets from './homepage-markets';

const TitleHero = () => {
  // SEO: Set page title and meta description
  useEffect(() => {
    document.title = "Mobile Notary Services for Title Companies | Pinpoint Field Services";

    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content',
        'Professional mobile notary services for title companies and escrow officers. Nationwide coverage, 24-hour turnaround, verified signing agents. Call (888) 530-7592.'
      );
    }

    // Add structured data for reviews and FAQ
    const schemaScript = document.createElement('script');
    schemaScript.type = 'application/ld+json';
    schemaScript.id = 'title-hero-schema';
    schemaScript.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "ProfessionalService",
          "@id": "https://www.pinpointfieldservices.com/#organization",
          "name": "Pinpoint Field Services",
          "description": "Mobile notary closing services for title companies, real estate attorneys, and mortgage lenders. Closers we know in each market — not a random dispatch pool.",
          "telephone": "+1-888-530-7592",
          "url": "https://www.pinpointfieldservices.com",
          "areaServed": "United States",
          "serviceType": ["Mobile Notary Closing", "Remote Online Notarization", "Loan Signing Services"],
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "5",
            "bestRating": "5",
            "ratingCount": "275",
            "reviewCount": "275"
          }
        },
        {
          "@type": "Review",
          "itemReviewed": { "@id": "https://www.pinpointfieldservices.com/#organization" },
          "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
          "author": { "@type": "Person", "name": "Settlement Agent" },
          "reviewBody": "As a settlement agent who works with several different mobile notary companies, I have to say Pinpoint is TOP NOTCH! Michael and his team are quick, reliable and I never have to worry about a lack of experience."
        },
        {
          "@type": "Review",
          "itemReviewed": { "@id": "https://www.pinpointfieldservices.com/#organization" },
          "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
          "author": { "@type": "Person", "name": "Barbara B." },
          "reviewBody": "Fantastic service to work with! Great communication and integrity!"
        },
        {
          "@type": "Review",
          "itemReviewed": { "@id": "https://www.pinpointfieldservices.com/#organization" },
          "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
          "author": { "@type": "Person", "name": "Janet S." },
          "reviewBody": "Love this company, they are very conscientious and do what they say they will do. I would work with them any day."
        },
        {
          "@type": "Review",
          "itemReviewed": { "@id": "https://www.pinpointfieldservices.com/#organization" },
          "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
          "author": { "@type": "Person", "name": "Mary" },
          "reviewBody": "I had an excellent experience working with Pinpoint Field Services. Their semi-automated, web-based system made the entire process smooth and easy to manage from start to finish. The helpful notifications at each step kept me informed, and compared to other notary signing companies, their platform made the signing process truly efficient and streamlined."
        },
        {
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "What areas do you cover for mobile notary services?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We cover closings in all 50 states. In many major metros, we use the same closers on a repeat basis — agents we know, not the nearest available name on a list. If we can't cover a closing, we'll tell you within the hour."
              }
            },
            {
              "@type": "Question",
              "name": "How quickly can you confirm coverage for a signing?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We confirm coverage within the hour. In our established markets, you'll get a closer we have an ongoing relationship with — someone who knows how we work. For rush requests, we'll tell you right away if we can cover it — we don't let you find out at closing time."
              }
            },
            {
              "@type": "Question",
              "name": "What types of signings do your closers handle?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Purchase closings, refinances, HELOCs, reverse mortgage signings, seller deed packages, quitclaim deeds, power of attorney notarizations, and Remote Online Notarization (RON). Our closers work exclusively in real estate — loan documents aren't new to them."
              }
            },
            {
              "@type": "Question",
              "name": "How do I track the status of a signing?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Every order is tracked in our portal with updates from scheduling through document return. Your whole team gets access — anyone can check status or message directly without chasing down an account manager."
              }
            }
          ]
        }
      ]
    });
    document.head.appendChild(schemaScript);

    // Cleanup: restore defaults on unmount
    return () => {
      document.title = "Pinpoint Field Services";
      if (metaDescription) {
        metaDescription.setAttribute('content',
          'Home page for Pinpoint Field Services - Providing peace of mind for closings and inspections.'
        );
      }
      const existingSchema = document.getElementById('title-hero-schema');
      if (existingSchema) {
        existingSchema.remove();
      }
    };
  }, []);

      const [showForm, setShowForm] = useState(false);
      const [formTitle, setFormTitle] = useState('Request a Signing')

  useEffect(() => {
    if (!showForm) return;
    document.body.style.overflow = 'hidden';
    const onKey = (e) => { if (e.key === 'Escape') setShowForm(false); };
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', onKey);
    };
  }, [showForm]);
      const [formComments, setFormComments] = useState('Company Name')
      const [formCommentsDescription, setFormCommentsDescription] = useState('Name of Title Company')
      const [apiRes, setApiRes] = useState('')
      const [showResponse, setShowResponse] = useState(false)
      const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        comments: '',
        subject: ''
      });



    const handleResponse = (e) => {
        setApiRes(e)
        setShowResponse(true)
        setFormData({
            ...formData,
            ['name']: '',
            ['email']: '',
            ['phone']: '',
            ['comments']: '',
            ['subject']: ''
        })
      }
      const handleShowForm = (param) => {
        if (param === 'notary') {
          setFormTitle('Request a Signing')
          setFormComments('Notarization Needs')
          setFormCommentsDescription('Please describe what you need notarized')
          mixpanel.track('Title Landing Page', {'action' : 'Show Notary Contact Us Form'})
        } else {
          setFormTitle('Request a Signing')
          setFormComments('Company Name')
          setFormCommentsDescription('Name of Title Company')
          mixpanel.track('Title Landing Page', {'action' : 'Show Title Company Contact Us Form'})
        }
        setShowForm(true);
      }

      const handleCloseForm = () => setShowForm(false);
      const [error, setError] = useState('');
      const api = RestHelperNoAuth()
    
        // Handle form input changes
        const handleChange = (e) => {
            setFormData({
              ...formData,
              [e.target.name]: e.target.value,
            });
          };
    
      // Function to handle form submission
      const handleSubmit = async (e) => {
        e.preventDefault(); // Prevent page reload on form submission
    
        // Simple validation example (you can add more specific checks if needed)
        if (!formData.name || !formData.email || !formData.phone || ! formData.comments) {
          setError('Please fill in all required fields');
          return;
        }
        mixpanel.track('Title Landing Page', {'action' : 'SubmitRequest'})
        try {
          // Send data to your API using fetch
          callApi()
           // Trigger Google Ads conversion event
          window.gtag('event', 'conversion', {
          'send_to': 'AW-1023542218/irtdCKSJ0YMaEMqHiOgD',
          'value': 1.0,
          'currency': 'USD',
        });
        } catch (error) {
          // Handle network errors
          setError('There was an error submitting your request. Please try again later.');
        }
      };
    
      const callApi = () => {
        const options = {}
        setShowForm(false)
        api
        .postCreate('/create-contact-request', options, formData)
        .then(res => handleResponse(res))
        .catch(err => console.log(err))
    }
  
    return (
      <main className="landing-page" role="main">
        {/* Hero Section */}
        <section className="hero-section">
          <div className="container">
            <div className="hero-content">
              <h1>Mobile Notary Services for Title Companies & Escrow Officers</h1>
              <p>We don't dispatch from a pool. We send closers we know — one or two agents per market who pick up when we call and know the documents.</p>

              <div className="d-flex flex-wrap justify-content-center mt-4 mb-4">
                <span className="benefit-tag">Nationwide Coverage</span>
                <span className="benefit-tag">Confirmed Within the Hour</span>
                <span className="benefit-tag">Closers We Know and Trust</span>
                <span className="benefit-tag">$2M E&O Coverage</span>
                <span className="benefit-tag">275+ Five-Star Reviews</span>
              </div>

              <button className="cta-button" onClick={() => handleShowForm('notary')}>Request a Signing</button>
              <p className="mt-3" style={{ color: '#d4d4d4' }}>
                <Link to="/about-us" style={{ color: '#00bfff' }}>Learn more about our company</Link> | <Link to="/support" style={{ color: '#00bfff' }}>Contact support</Link>
              </p>
            </div>
          </div>
        </section>

        {/* Persona Cards */}
        <HomepagePersonaCards />

  
        {/* Stats Section */}
        <section className="stats-section">
          <div className="container">
            <div className="row text-center">
              <div className="col-md-3 col-sm-6 mb-4 stat-card">
                <h3>★★★★★</h3>
                <p>Google Reviews Rating</p>
              </div>
              <div className="col-md-3 col-sm-6 mb-4 stat-card">
                <h3>20+</h3>
                <p>Years of Industry Experience</p>
              </div>
              <div className="col-md-3 col-sm-6 mb-4 stat-card">
                <h3>2,300+</h3>
                <p>Closings Completed</p>
              </div>
              <div className="col-md-3 col-sm-6 mb-4 stat-card">
                <h3>1 Hour</h3>
                <p>Confirmation on Every Request</p>
              </div>
              
            </div>
          </div>

        </section>

        {/* Services Section */}
        <HomepageServices />

        {/* Markets Section */}
        <HomepageMarkets />

        {/* Features Section */}
        <section className="features-section">
          <div className="container">
            <div className="text-center mb-5">
              <h2>Built for Title Companies and Escrow Offices</h2>
              <p className="mb-5">We work the way title companies need us to work — fast confirmation, consistent closers, and no surprises at the table.</p>
            </div>
            
            <div className="row g-4">
              {/* Feature 1 */}
              <div className="col-lg-4 col-md-6">
                <div className="feature-card h-100">
                  <h3>Loan Closings</h3>
                  <p>Our closers know the documents. They follow your instructions and don't call back with basic questions at closing time.</p>
                </div>
              </div>
              
              {/* Feature 2 */}
              <div className="col-lg-4 col-md-6">
                <div className="feature-card h-100">
                  <h3>Rush Signings</h3>
                  <p>Need coverage today? We confirm within the hour. If we can't cover it, we tell you right away — not after the borrower is already waiting.</p>
                </div>
              </div>
              
              {/* Feature 3 */}
              <div className="col-lg-4 col-md-6">
                <div className="feature-card h-100">
                  <h3>Remote Locations</h3>
                  <p>Rural areas, after-hours, last-minute. We don't filter for easy orders. If we can't cover it, we say so immediately.</p>
                </div>
              </div>
              
              {/* Feature 4 */}
              <div className="col-lg-4 col-md-6">
                <div className="feature-card h-100">
                  <h3>Real-Time Updates</h3>
                  <p>Track every order in the portal. Status updates at each stage, from scheduling through document return — no need to chase us for status.</p>
                </div>
              </div>
              
              {/* Feature 5 */}
              <div className="col-lg-4 col-md-6">
                <div className="feature-card h-100">
                  <h3>Message Center</h3>
                  <p>All order communication in one place. Your whole escrow team gets access — so anyone can pick up where someone else left off.</p>
                </div>
              </div>
              
              {/* Feature 6 */}
              <div className="col-lg-4 col-md-6">
                <div className="feature-card h-100">
                  <h3>Document Tracking</h3>
                  <p>Our secure system tracks all documents from printing to return shipping, ensuring nothing gets lost in the process.</p>
                </div>
              </div>
            </div>
          </div>
        </section>
  
  
        {/* Process Section */}
        <section className="process-section">
          <div className="container">
            <div className="text-center mb-5">
              <h2>How it works</h2>
              <p className="mb-4">Submit an order in under a minute. We handle the rest.</p>
            </div>
            
            <div className="mx-auto" style={{ maxWidth: '800px' }}>
              {/* Step 1 */}
              <div className="process-step">
                <div className="step-number">1</div>
                <div>
                  <h4>Submit Your Request</h4>
                  <p>Use our portal or call us with the signing details. We confirm receipt within minutes.</p>
                </div>
              </div>
              
              {/* Step 2 */}
              <div className="process-step">
                <div className="step-number">2</div>
                <div>
                  <h4>We Handle Scheduling</h4>
                  <p>Our team contacts the signers, arranges a convenient time, and confirms the appointment with all parties.</p>
                </div>
              </div>
              
              {/* Step 3 */}
              <div className="process-step">
                <div className="step-number">3</div>
                <div>
                  <h4>Closer Assigned</h4>
                  <p>We assign one of the closers we know in that market — not the nearest available name on a list.</p>
                </div>
              </div>
              
              {/* Step 4 */}
              <div className="process-step">
                <div className="step-number">4</div>
                <div>
                  <h4>Signing Completed</h4>
                  <p>The notary executes the signing according to your instructions and provides immediate confirmation upon completion.</p>
                </div>
              </div>
              
              {/* Step 5 */}
              <div className="process-step">
                <div className="step-number">5</div>
                <div>
                  <h4>Secure Document Return</h4>
                  <p>Documents are returned via your preferred method—overnight shipping, secure upload, or courier service.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials */}
        <section className="testimonials-section">
          <div className="container">
            <div className="text-center mb-5">
              <h2>Trusted by Title Companies Nationwide</h2>
              <p>Don't just take our word for it. Here's what our clients have to say.</p>
            </div>
            
            <div className="row">
              {/* Testimonial 1 */}
              <div className="col-lg-6 col-md-6">
                <article className="testimonial-card">
                  <blockquote className="testimonial-content">
                    "As a settlement agent who works with several different mobile notary companies, I have to say Pinpoint is TOP NOTCH! Michael and his team are quick, reliable and I never have to worry about a lack of experience. The process and systems for Pinpoint are so user friendly and makes my job that much easier!"
                  </blockquote>
                  <footer className="testimonial-author">
                    <cite>
                      <strong>Settlement Agent</strong>
                      <span className="testimonial-role">Nebraska</span>
                    </cite>
                  </footer>
                </article>
              </div>

              {/* Testimonial 2 */}
              <div className="col-lg-6 col-md-6">
                <article className="testimonial-card">
                  <blockquote className="testimonial-content">
                    "Pinpoint Field Services offers not only professional and prompt service as a course of regular business, but has also stepped in and gone above and beyond to get things done when needed. This level of support helps everyone involved achieve a common goal and they understand how valuable that is. I trust them wholly to be that valued partner that helps me do my job better."
                  </blockquote>
                  <footer className="testimonial-author">
                    <cite>
                      <strong>Escrow Officer</strong>
                      <span className="testimonial-role">Title Company, Nebraska</span>
                    </cite>
                  </footer>
                </article>
              </div>

            </div>
          </div>
        </section>

        
      {/* Google Reviews Section */}
      <section className="reviews-section">
        <h2>Google Reviews</h2>
        <div className="google-reviews col">
          {/* Placeholder for embedding Google Reviews */}
          <p>★★★★★</p>
          <p>"Fantastic service to work with! Great communication and integrity!" - Barbara B.</p>
        </div>
        <hr/>
        <div className="google-reviews col">
          {/* Placeholder for embedding Google Reviews */}
          <p>★★★★★</p>
          <p>"Love this company, they are very conscientious and do what they say they will do. I would work with them any day." - Janet S.</p>
        </div>
        <hr/>
        <div className="google-reviews col">
          <p>★★★★★</p>
          <p>"I had an excellent experience working with Pinpoint Field Services. Their semi-automated, web-based system made the entire process smooth and easy to manage from start to finish. The helpful notifications at each step kept me informed, and compared to other notary signing companies, their platform made the signing process truly efficient and streamlined." - Mary, New York City</p>
        </div>
        <a
          href="https://www.google.com/search?q=pinpoint+field+services"
          target="_blank"
          rel="noopener noreferrer"
          style={{ display: 'inline-block', marginTop: '1rem', fontSize: '0.9rem', color: '#00bfff', textDecoration: 'none' }}
        >
          See all 275+ reviews on Google →
        </a>
      </section>

        {/* FAQ Section */}
        <section className="faq-section" aria-labelledby="faq-heading">
          <div className="container">
            <div className="text-center mb-5">
              <h2 id="faq-heading">Frequently Asked Questions</h2>
              <p>Common questions from title companies and escrow officers</p>
            </div>

            <div className="faq-container">
              <div className="faq-item">
                <h3>What areas do you cover for mobile notary services?</h3>
                <p>We cover closings in all 50 states. In many major metros, we use the same closers on a repeat basis — agents we know, not the nearest available name on a list. If we can't cover a closing, we'll tell you within the hour.</p>
              </div>

              <div className="faq-item">
                <h3>How quickly can you confirm coverage for a signing?</h3>
                <p>We confirm coverage within the hour. In our established markets, you'll get a closer we have an ongoing relationship with — someone who knows how we work. For rush requests, we'll tell you right away if we can cover it — we don't let you find out at closing time.</p>
              </div>

              <div className="faq-item">
                <h3>What types of signings do your closers handle?</h3>
                <p>Purchase closings, refinances, HELOCs, reverse mortgage signings, seller deed packages, quitclaim deeds, power of attorney notarizations, and Remote Online Notarization (RON). Our closers work exclusively in real estate — loan documents aren't new to them.</p>
              </div>

              <div className="faq-item">
                <h3>How do I track the status of a signing?</h3>
                <p>Every order is tracked in our portal with updates from scheduling through document return. Your whole team gets access — anyone can check status or message directly without chasing down an account manager.</p>
              </div>
            </div>

            <div className="text-center mt-4">
              <p>Have more questions? <Link to="/support" style={{ color: '#00bfff', fontWeight: 'bold' }}>Contact our support team</Link></p>
            </div>
          </div>
        </section>

        {/* Signing Agent CTA */}
        <section className="info-section" style={{ backgroundColor: '#e8f4fc' }}>
          <div className="container text-center">
            <h3>Are You a Signing Agent?</h3>
            <p>Join our nationwide network of verified notary signing agents. We're always looking for experienced professionals.</p>
            <Link to="/sign-up" className="cta-button" style={{ display: 'inline-block', textDecoration: 'none' }}>Apply to Join Our Network</Link>
          </div>
        </section>

        {/* CTA Section / Contact */}
        <section id="contact" className="hero-section">
          <div className="container">
            <h2>Ready to put us on your next closing?</h2>
            <p className="mb-4">Send us a closing. We'll confirm coverage within the hour and assign a closer we know in that market.</p>
            <button className="cta-button" onClick={() => handleShowForm('default')}>Request a Signing</button>
            <p className="mt-3">Or call us directly: <a href="tel:8885307592" className="phone-link">(888) 530-7592</a></p>
            <p className="mt-4" style={{ color: '#d4d4d4', fontSize: '0.9rem' }}>
              <Link to="/about-us" style={{ color: '#00bfff' }}>About Us</Link> | <Link to="/support" style={{ color: '#00bfff' }}>Support</Link> | <Link to="/sign-up" style={{ color: '#00bfff' }}>Become a Signing Agent</Link>
            </p>
          </div>
        </section>
  
        {/* Success message */}
        {showResponse && (
          <div className="info-section">
            <p>{apiRes}</p>
          </div>
        )}

        {/* Request a Signing Modal */}
        {showForm && (
          <div
            className="modal-backdrop"
            onClick={handleCloseForm}
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-title"
          >
            <div className="modal-card" onClick={(e) => e.stopPropagation()}>
              <div className="form-header">
                <h2 id="modal-title">{formTitle}</h2>
                <button className="close-button" onClick={handleCloseForm} aria-label="Close form">✕</button>
              </div>
              <form className="appraisal-form" onSubmit={handleSubmit}>
                <p style={{ marginBottom: '1.25rem', color: '#4a5568' }}>
                  Fill out the form below or call us at <a href="tel:888-530-7592" className="phone-link">(888) 530-7592</a>. We'll be in touch soon.
                </p>
                <label>Name:</label>
                <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder="Your Name" required />

                <label>Email Address:</label>
                <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="Your Email" required />

                <label>Callback Number:</label>
                <input type="tel" name="phone" value={formData.phone} onChange={handleChange} placeholder="Your Phone Number" required />

                <label>{formComments}:</label>
                <textarea name="comments" value={formData.comments} onChange={handleChange} placeholder={formCommentsDescription} />

                <label>City, State:</label>
                <input type="text" name="subject" value={formData.subject} onChange={handleChange} placeholder="City, State" />

                {error && <p className="error-message">{error}</p>}

                <button type="submit" className="submit-button">Submit Request</button>
              </form>
            </div>
          </div>
        )}

      </main>
    );
  };

export default TitleHero;